import { useEffect, useState } from 'react';
import { usePHSPACCResultProgressComplete } from '@components/common/header/messageModal/messages/companyMessage/resultRequest/query/usePHSPACCResultsProgressComplete';
import { usePHSPSTResultProgressComplete } from '@components/common/header/messageModal/messages/companyMessage/resultRequest/query/usePHSPSTProgressComplete';
import { useAccResultProgressComplete } from '@components/common/header/messageModal/messages/companyMessage/resultRequest/query/useAccResultsProgressComplete';
import { useUserInfo } from '@repository/auth/useUserInfo';
import useProfilesType from '@components/match/query/useProfilesType';
import ProfileTab from '@components/match/profile/profileTab';
import ProfileCard from '@components/match/profile/profileCard';
import { ProfileInfoType } from '@components/match/profile/types';
import MatchProposal from '@components/match/profile/matchProposal';
import { useGetMatchConfigStatus, useMatchProfile } from '@repository/match';
import { AccProgressCompleteVO } from '@domain/vo/acca/test/AccProgressCompleteListVO';
import { PaccProgressCompleteVO } from '@domain/vo/phs/pacc/results/PaccProgressCompleteListVO';
import { PstProgressCompleteVO } from '@domain/vo/phs/pst/result/PstProgressCompleteListVO';
import { ApplyType } from '@domain/rs/match/MatchingProfileRs';

const Profile = () => {
  const [isInit, setIsInit] = useState(false);
  const [profileInfoType, setProfileInfoType] = useState<ProfileInfoType>('GENERAL');
  const [currentApplyType, setCurrentApplyType] = useState<ApplyType | null>(null);
  const [isJobSelectNeeded, setIsJobSelectNeeded] = useState(false);
  const [selectedResultSn, setSelectedResultSn] = useState<number | null>(null);
  const [resultsData, setResultsData] = useState<
    AccProgressCompleteVO[] | PaccProgressCompleteVO[] | PstProgressCompleteVO[] | null
  >(null);

  const { data: userInfo } = useUserInfo();
  const isLogin = !!userInfo?.id;

  const { data: profilesTypeData } = useProfilesType(isLogin);
  const { data: matchProfile } = useMatchProfile();
  const { data: matchConfigStatus } = useGetMatchConfigStatus(isLogin);

  const { data: PACCdata } = usePHSPACCResultProgressComplete();
  const { data: PSTdata } = usePHSPSTResultProgressComplete();
  const { data: ACCdata } = useAccResultProgressComplete();

  const onClickTab = (type: ProfileInfoType) => {
    setProfileInfoType(type);
  };

  useEffect(() => {
    if (!profilesTypeData || isInit) return;

    if (profilesTypeData.developerYn) {
      setProfileInfoType('DEVELOPER');
    } else {
      setProfileInfoType('GENERAL');
    }

    setIsInit(true);
  }, [profilesTypeData, isInit]);

  useEffect(() => {
    if (!profilesTypeData) return;

    // 일반 매칭 탭 & 직무 선택 전
    const isGeneralTabAndNotJobSelect = profileInfoType === 'GENERAL' && !profilesTypeData.generalYn;
    // 개발자 매칭 탭 & 직무 선택 전
    const isDeveloperTabAndNotJobSelect = profileInfoType === 'DEVELOPER' && !profilesTypeData.developerYn;

    if (isGeneralTabAndNotJobSelect || isDeveloperTabAndNotJobSelect) {
      setIsJobSelectNeeded(true);
    } else {
      setIsJobSelectNeeded(false);
    }
  }, [profileInfoType, profilesTypeData]);

  useEffect(() => {
    if (ACCdata && currentApplyType === 'ACC') setResultsData(ACCdata.resultRecords);
    if (PACCdata && currentApplyType === 'PACC') setResultsData(PACCdata.resultRecords);
    if (PSTdata && currentApplyType === 'PST') setResultsData(PSTdata.resultRecords);
  }, [currentApplyType, ACCdata, PACCdata, PSTdata]);

  const onSuccessJobSelect = () => {
    setIsJobSelectNeeded(false);
  };

  if (!matchProfile || !userInfo || !profilesTypeData || !matchProfile) return null;

  return (
    <>
      <ProfileTab activeTab={profileInfoType} onClickTab={onClickTab} />
      <ProfileCard
        name={userInfo?.name ?? ''}
        profileInfoType={profileInfoType}
        isJobSelectNeeded={isJobSelectNeeded}
        matchProfile={matchProfile}
        selectedResultSn={selectedResultSn}
        setSelectedResultSn={setSelectedResultSn}
        resultsData={resultsData}
        currentApplyType={currentApplyType}
        setCurrentApplyType={setCurrentApplyType}
        onSuccessJobSelect={onSuccessJobSelect}
        matchingConfigYn={matchConfigStatus?.matchingConfigYn}
      />
      {!isJobSelectNeeded && <MatchProposal />}
    </>
  );
};

export default Profile;
